module.exports = __webpack_public_path__ + "static/media/mobile.ad8c9161.mp4";